export default "__VITE_ASSET__f39f0dc0__"